import { Button, Col, Form, Radio, Row, Space } from "antd";
import { InputFields } from "components/common";
import ModalResults from "components/common/ModalTable/ModalTable";
import React, { useEffect, useState } from "react";
import {
  convertIosStringToDateDayjs,
  formatDateToStringTimezone_7,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import consultantAndFragmentService from "api/consulantAndFragtment";
import { setDataConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import Notification from "components/common/notification/notification";
import dayjs from "dayjs";
import fieldsAgree from "./config";

const ModalAgree = ({ isShowModalAgree, setIsShowModalAgree, patientRef }) => {
  const [form] = Form.useForm();
  const handleCancel = () => {
    setIsShowModalAgree(false);
  };
  const idConsultantInfo = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantInfo
  );
  const id = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantAndFragment
  );

  const [fields, setFields] = useState(fieldsAgree(FIELD_TYPE.DATE_PRE));

  const dispatch = useAppDispatch();

  const updateSurgeryAgree = async (method, data) => {
    try {
      const res = await consultantAndFragmentService[method](data);
      const newData = await res?.lichSuTuVanDtos?.map((item) => ({
        ...item,
        key: item.id,
      }));

      setIsShowModalAgree({
        type: "old",
        isShow: false,
      });
      if ((isShowModalAgree.type = "old")) {
        Notification("success", "Cập nhật đặt lịch phẫu thuật thành công");
      } else
        Notification("error", "Đặt lịch phẫu thuật không thành thành công ");
      return { res, newData };
    } catch (error) {
      if ((isShowModalAgree.type = "new")) {
        Notification("error", " Đặt lịch phẫu thuật không thành công ");
      } else
        Notification("error", "Đã xảy ra lỗi trong quá trình lấy dữ liệu ");
    }
  };
  const datapatient = useAppSelector((e) => e.consultantAndFragment.data);
  const handleSubmit = async () => {
    form.validateFields().then(async (value) => {
      const newValue = {
        ...value,
        id: idConsultantInfo,
        idPhieuTuVan: id,
        thoiGianHen: formatDateToStringTimezone_7(
          value.thoiGianHen,
          isShowModalAgree.type === "new" ? true : false
        ),
      };
      if (isShowModalAgree.type === "new") {
        const res: any = await updateSurgeryAgree("postSurgeryAgree", newValue);
        const updatedLichSuTuVanDtos = [
          res.newData[0],
          ...datapatient?.lichSuTuVanDtos,
        ];
        const patientInfo = patientRef.current?.getFormValue();
        dispatch(
          setDataConsultantAndFragment({
            ...value,
            ...datapatient,
            lichSuTuVanDtos: updatedLichSuTuVanDtos,
            loaiPhauThuat: patientInfo?.loaiPhauThuat,
          })
        );
      } else {
        const res: any = await updateSurgeryAgree("putSurgeryAgree", newValue);
        const updatedLichSuTuVanDtos = [
          res.newData[0],
          ...datapatient?.lichSuTuVanDtos,
        ];

        dispatch(
          setDataConsultantAndFragment({
            ...value,
            ...datapatient,
            lichSuTuVanDtos: res.newData,
            loaiPhauThuat: value?.loaiPhauThuat ?? res.loaiPhauThuat,
          })
        );
      }
    });
  };

  const getSurgeryAgree = async () => {
    try {
      const res = await consultantAndFragmentService.getSurgeryAgree(
        idConsultantInfo
      );

      if (res.thoiGianPhauThuat === 0) {
        setFields(fieldsAgree(FIELD_TYPE.DATE_ON));
      }

      form.setFieldsValue({
        ...res,
        thoiGianHen: convertIosStringToDateDayjs(res.thoiGianHen),
      });
    } catch (error) {
      if ((isShowModalAgree.type = "new")) {
        Notification("error", " Đặt lịch phẫu thuật không thành công ");
      } else
        Notification("error", "Đã xảy ra lỗi trong quá trình lấy dữ liệu ");
    }
  };

  useEffect(() => {
    if (idConsultantInfo) {
      getSurgeryAgree();
    } else {
      form.resetFields();
      setFields(fieldsAgree(FIELD_TYPE.DATE_ON));
    }
  }, [idConsultantInfo]);

  return (
    <ModalResults
      title={"Đặt lịch phẫu thuật"}
      isShowModal={isShowModalAgree.isShow}
      handleCancel={handleCancel}
      heightContent={200}
      minHeight={200}
    >
      <Form
        form={form}
        initialValues={{
          thoiGianHen: convertDateStringToDateTimezone_7(dayjs()),
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xl={24} lg={24} xs={24}>
            <Form.Item
              label="Thời gian phẫu thuật"
              initialValue={0}
              name={"thoiGianPhauThuat"}
              wrapperCol={{ xs: 14, md: 16, lg: 16 }}
              labelCol={{ xs: 10, md: 8, lg: 8 }}
              labelAlign="left"
            >
              <Radio.Group>
                <Radio
                  value={0}
                  onChange={() => {
                    form.setFieldsValue({
                      thoiGianHen: convertDateStringToDateTimezone_7(dayjs()),
                    });
                    setFields(fieldsAgree(FIELD_TYPE.DATE_ON));
                  }}
                >
                  Trong ngày
                </Radio>
                <Radio
                  value={1}
                  onChange={() => {
                    setFields(fieldsAgree(FIELD_TYPE.DATE_PRE));
                  }}
                >
                  Hẹn lịch
                </Radio>
                ;
              </Radio.Group>
            </Form.Item>
          </Col>
          <InputFields data={fields} />
        </Row>
        <Row style={{ marginTop: "10px" }} justify={"end"}>
          <Space>
            <Button key="cancel" type="primary" danger onClick={handleCancel}>
              Huỷ bỏ
            </Button>

            <Button
              key="submit"
              type="primary"
              htmlType="submit"
              onClick={handleSubmit}
            >
              Lưu lại
            </Button>
          </Space>
        </Row>
      </Form>
    </ModalResults>
  );
};

export default ModalAgree;
